import * as React from "react";
import { forwardRef } from "react";
const SvgAction = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7.964 1.999v4.997h3.972l-3.972 6.997V8.995H3.992zM7.959 0a1.98 1.98 0 0 0-1.724 1.007L2.263 8.004a2.01 2.01 0 0 0 .731 2.73c.301.175.644.268.993.268h1.986v2.999a2 2 0 0 0 1.476 1.932 1.98 1.98 0 0 0 2.234-.94l3.93-6.924a2 2 0 0 0-1.677-3.072H9.945V2A2 2 0 0 0 8.468.067 2 2 0 0 0 7.958 0" }));
const ForwardRef = forwardRef(SvgAction);
export { ForwardRef as ReactComponent };
